import React from 'react';
import useStyle from './dialogContent.style';

export interface DialogContentProps {
  dialogTitle: string;
  children: JSX.Element;
}

export const DialogContent = ({
  dialogTitle,
  children
}: DialogContentProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <span>{dialogTitle}</span>
      {children}
    </div>
  );
};
